import { api } from '../configs/axiosConfigs';
import { BuyerProfileValues, LicenseType } from '../../utility/team';

export const getTeamConnections = async () => api.get('/team_connections');

export const createTeamConnection = async (email: string, role: 'agent' | 'buyer') =>
  api.post('/team_connections', { email, role });

export const acceptTeamConnection = async (id: string) => api.post(`/team_connections/${id}/accept`);
export const declineTeamConnection = async (id: string) => api.post(`/team_connections/${id}/decline`);
export const endTeamConnection = async (id: string) => api.post(`/team_connections/${id}/end_connection`);
// The buyer lets (or stops) this agent applying the buyer's saved signature.
export const setSigningAuthority = async (id: string, allowed: boolean) =>
  api.post(`/team_connections/${id}/signing_authority`, { allowed });

export type LicenseInput = { license_type: LicenseType; state: string; license_number: string };

export const getProfessionalLicenses = async () => api.get('/professional_licenses');
export const createProfessionalLicense = async (license: LicenseInput) =>
  api.post('/professional_licenses', { professional_license: license });
export const deleteProfessionalLicense = async (id: string) => api.delete(`/professional_licenses/${id}`);

export const getBuyerProfiles = async (buyerId?: string) =>
  api.get('/buyer_profiles', { params: buyerId ? { buyer_id: buyerId } : {} });
export const createBuyerProfile = async (values: BuyerProfileValues, buyerId?: string) =>
  api.post('/buyer_profiles', { buyer_profile: values }, { params: buyerId ? { buyer_id: buyerId } : {} });
export const updateBuyerProfile = async (id: string, values: BuyerProfileValues, buyerId?: string) =>
  api.put(`/buyer_profiles/${id}`, { buyer_profile: values }, { params: buyerId ? { buyer_id: buyerId } : {} });
export const deleteBuyerProfile = async (id: string, buyerId?: string) =>
  api.delete(`/buyer_profiles/${id}`, { params: buyerId ? { buyer_id: buyerId } : {} });

// Which connected agents may use one of my buyer profiles (owner only).
export const getProfileShares = async (profileId: string) => api.get(`/buyer_profiles/${profileId}/shares`);
export const shareProfileWithAgent = async (profileId: string, agentId: string) =>
  api.post(`/buyer_profiles/${profileId}/shares`, { agent_id: agentId });
export const unshareProfileWithAgent = async (profileId: string, agentId: string) =>
  api.delete(`/buyer_profiles/${profileId}/shares/${agentId}`);
